<template>
  <div class="w-[100lvw] h-[100lvh] bg-cw-orange flex flex-col items-center justify-center">
    <Loader :size="200" v-if="isLoading" />
    <template v-if="errorMessage">
      <h1>An error occurred</h1>
      <BaseButton background-color="var(--color-cw-red-light)" border-color="#471F20" @click="exitGame">
        <ArrowFatLeftIcon />
        Exit game
      </BaseButton>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue'
import Loader from '@/components/interface/Loader.vue'
import { useRoute, useRouter } from 'vue-router'
import { useHelpers } from '@/composables/useHelpers'
import UserService from '@/services/api/user-service'
import { useUserStore } from '@/stores/user'
import BaseButton from '@/components/base/BaseButton.vue'
import ArrowFatLeftIcon from '@/assets/svgs/icons/arrow-fat-left.svg'
import { AppWindowEvent } from '@/types/Events'
import { useAppStore } from '@/stores/app'
import { storeToRefs } from 'pinia'

const { setCookie, sleep, sendParentWindowMessage } = useHelpers()
const { setUser } = useUserStore()
const { isSoundEnabled } = storeToRefs(useAppStore())

const errorMessage = ref('')
const isLoading = ref(true)
const router = useRouter()
const route = useRoute()

const loginUser = async () => {
  errorMessage.value = ''
  try {
    const access_token = route.query.access_token as string
    const config = JSON.parse((route.query.config as string) || '{}')
    isSoundEnabled.value = config.isSoundEnabled ?? true

    setCookie('access_token', access_token, 1)
    await nextTick()

    const { data: user } = await UserService.getProfile()
    setUser(user)
    await nextTick()
    close()
    await sleep(200)
    router.push('/')
  } catch (error: ApiError) {
    errorMessage.value = error.data?.message || 'An error occurred while logging in.'
  } finally {
    isLoading.value = false
  }
}

const exitGame = () => {
  sendParentWindowMessage(AppWindowEvent.ExitGame)
}

loginUser()
</script>

<style scoped></style>
